class LookbookModal extends ModalDialog {
  constructor() {
    super();
    this.swiper = null;
    this.swiperEl = null;
    this.modalContent = null;
  }

  connectedCallback() {
    super.connectedCallback();
    this.swiperEl = this.querySelector('[data-lookbook-swiper]');
    this.modalContent = this.querySelector('.lookbook-lightbox-modal__content');
    this.bindLookbookEvents();
    this.bindBackdropClick();
  }

  bindBackdropClick() {
    if (this.modalContent) {
      this.modalContent.addEventListener('click', (event) => {
        const isInteractive = event.target.closest(
          '.lookbook-lightbox-modal__slide-content, .swiper-button-prev, .swiper-button-next, .swiper-pagination'
        );
        if (!isInteractive) this.hide();
      });
    }
  }

  initSwiper() {
    if (!this.swiperEl || typeof Swiper === 'undefined') return;

    // Destroy existing swiper if it exists
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      autoheight: true,
      watchSlidesVisibility: false,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      loop: false,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: '.lookbook-swiper-button-next',
        prevEl: '.lookbook-swiper-button-prev',
      },
      pagination: {
        el: '.lookbook-swiper-pagination',
        clickable: true,
      },
    });
  }

  show(opener, slideIndex) {
    if (!this.swiper) {
      this.initSwiper();
    }

    // Call parent show method
    super.show(opener);

    // Navigate to specific slide if provided
    if (this.swiper && slideIndex !== undefined) {
      setTimeout(() => {
        this.swiper.slideTo(slideIndex, 0);
      }, 50);
    }
  }

  hide() {
    // Pause any playing videos
    const videos = this.querySelectorAll('video');
    videos.forEach((video) => {
      if (!video.paused) {
        video.pause();
      }
    });

    super.hide();
  }

  bindLookbookEvents() {
    const sectionId = this.id.replace('LookbookModal-', '');
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);

    if (!section) return;

    // Use event delegation for better performance
    section.addEventListener('click', (e) => {
      const button = e.target.closest('[data-lookbook-open-modal]');
      if (button) {
        e.preventDefault();
        const slideIndex = parseInt(button.getAttribute('data-slide-index'), 10);
        this.show(button, slideIndex);
      }
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('lookbook-modal', LookbookModal);
